import { useRef, useEffect, useState } from 'react'

export const VideoPlayer = (props) => {
  const [player, setPlayer] = useState(null)
  const id = useRef(`betterplace-video-player-${Math.random().toString(36).substr(2, 9)}`)

  const onYoutubeReady = () => {
    let player = new YT.Player(id.current, {
      events: {
        // onStateChange: () => this.state.videoStarted || this.setState({videoStarted: true})
      }
    })
    setPlayer(player)
  }

  useEffect(() => {
    window.onYouTubeIframeAPIReady = onYoutubeReady
    const script = document.createElement('script')
    script.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
  }, [])

  return <iframe
    allowFullScreen
    type='text/html'
    width='508'
    height='286'
    id={id.current}
    src={props.videoUrl}
    frameBorder="0"
  />
}
